module.exports = __webpack_public_path__ + "media/flags/010-india-c83edfa6.svg";